import React from "react";

import SendIcon from "@mui/icons-material/Send";

function EndPointIcon({ iconColor, iconSize = "small", ...other }) {
    return <SendIcon color={iconColor} fontSize={iconSize} {...other} />;
}

export default EndPointIcon;
